'use strict';

const processInclude = require('base/util');

function initRecommendation() {
  const $noresultRecommendationsWrapper = $('.noresult-recommendations-wrapper');

  if ($noresultRecommendationsWrapper.length) {
    $.ajax({
      url: $noresultRecommendationsWrapper.data('url'),
      type: 'get',
      success: function (data) {
        $noresultRecommendationsWrapper.html(data);
      }
    });
  }

  const categoryRefinementsMobile = $('.category-refinment-mobile').children().length;
  const headerTitle = $('h1.search-results-header').length;

  if (!categoryRefinementsMobile && !headerTitle) {
    $('#product-search-results').addClass('no-category-refinments-or-title');
  } else if (!categoryRefinementsMobile && headerTitle) {
    $('#product-search-results').addClass('no-category-refinments');
  } else if (categoryRefinementsMobile && !headerTitle) {
    $('#product-search-results').addClass('no-title');
  }
}

$(document).ready(function () {
  processInclude(window.productWishListHeart);
  processInclude(window.productWishList);
  initRecommendation();
});
